import { CoinSVG } from './CoinSVG';

export function Logo({ compact = false }: { compact?: boolean }) {
  return <div className={`logo ${compact ? 'logo--compact' : ''}`}><span className="logo__coins"><CoinSVG rank={2} side="silver" size={compact ? 36 : 56} /><CoinSVG rank={3} side="gold" size={compact ? 40 : 62} /></span><span>Chance &amp; Change</span></div>;
}
